import React from 'react';
import { ContentSection } from '../ui/ContentSection';
import { Book, Headphones, Map, Check } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { motion } from 'framer-motion';
export function PackageIncludes() {
  return <ContentSection background="white" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-113">
          <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-114">
            QUÉ INCLUYE
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-4" data-id="element-115">
            Lo que recibes hoy por
          </h2>
          <div className="inline-flex items-baseline gap-2" data-id="element-116">
            <span className="text-6xl md:text-7xl font-bold text-[#F59E0B]" data-id="element-117">
              $9.97
            </span>
          </div>
        </div>

        {/* Package Items */}
        <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-100 rounded-3xl p-8 md:p-12 mb-8 shadow-lg" data-id="element-118">
          <div className="space-y-8" data-id="element-119">
            {/* Item 1 - Main Book */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="flex gap-4 items-start" data-id="element-120">
              <div className="flex-shrink-0" data-id="element-121">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center" data-id="element-122">
                  <Check className="w-6 h-6 text-green-600" data-id="element-123" />
                </div>
              </div>
              <div className="flex-1" data-id="element-124">
                <div className="flex items-center gap-3 mb-2" data-id="element-125">
                  <Book className="w-6 h-6 text-amber-600" data-id="element-126" />
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-127">
                    Libro digital – Juega Desde Otro Nivel
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed" data-id="element-128">
                  Marco completo para detectar tu techo invisible, ordenar
                  decisiones y subir de nivel con claridad.
                </p>
              </div>
            </motion.div>

            {/* Item 2 - Audiobook BONUS */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="flex gap-4 items-start" data-id="element-129">
              <div className="flex-shrink-0" data-id="element-130">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center" data-id="element-131">
                  <Check className="w-6 h-6 text-green-600" data-id="element-132" />
                </div>
              </div>
              <div className="flex-1" data-id="element-133">
                <div className="flex items-center gap-3 mb-2" data-id="element-134">
                  <Headphones className="w-6 h-6 text-amber-600" data-id="element-135" />
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-136">
                    Audiolibro
                  </h3>
                  <span className="px-3 py-1 bg-amber-100 text-amber-800 text-xs font-bold rounded-full" data-id="element-137">
                    BONUS
                  </span>
                </div>
                <p className="text-gray-600 leading-relaxed" data-id="element-138">
                  Para reforzar las ideas clave mientras caminas, manejas o
                  entrenas.
                </p>
              </div>
            </motion.div>

            {/* Item 3 - Time Management Map BONUS */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex gap-4 items-start" data-id="element-139">
              <div className="flex-shrink-0" data-id="element-140">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center" data-id="element-141">
                  <Check className="w-6 h-6 text-green-600" data-id="element-142" />
                </div>
              </div>
              <div className="flex-1" data-id="element-143">
                <div className="flex items-center gap-3 mb-2" data-id="element-144">
                  <Map className="w-6 h-6 text-amber-600" data-id="element-145" />
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-146">
                    Mapa de Gestión de Tiempo
                  </h3>
                  <span className="px-3 py-1 bg-amber-100 text-amber-800 text-xs font-bold rounded-full" data-id="element-147">
                    BONUS
                  </span>
                </div>
                <p className="text-gray-600 leading-relaxed" data-id="element-148">
                  Herramienta práctica para filtrar tareas, proteger energía y
                  enfocar tu día desde el día 1.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Delivery Info */}
          <div className="mt-10 pt-8 border-t border-gray-200 text-center" data-id="element-149">
            <p className="text-gray-600 mb-2" data-id="element-150">
              <span className="font-semibold text-gray-900" data-id="element-151">
                Entrega inmediata.
              </span>
            </p>
            <p className="text-gray-600" data-id="element-152">
              <span className="font-semibold text-gray-900" data-id="element-153">
                Aplicación desde el día 1.
              </span>
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-154">
          <CTAButton href="https://coneckta.co/ebookjuegadesdeotronivel" className="text-xl px-12 py-6" data-id="element-155">
            SÍ, LO QUIERO — $9.97
          </CTAButton>
          <p className="mt-4 text-sm text-gray-500" data-id="element-156">
            Incluye Audiolibro + Mapa de Gestión de Tiempo
          </p>
        </div>
      </div>
    </ContentSection>;
}